import { render, staticRenderFns } from "./ProjectStatic.vue?vue&type=template&id=1027924c&"
import script from "./ProjectStatic.vue?vue&type=script&lang=js&"
export * from "./ProjectStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports